var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v("Авторизация")]),_c('p',[_vm._v("Войдите в учетную запись Талант")]),_c('v-btn',{attrs:{"href":_vm.loginURL,"color":"primary"}},[_vm._v("Войти")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }